module.exports = __webpack_public_path__ + "static/media/photo_019.7b94e567.JPG";